import { isCrossFarmDashboardHomePathname } from '../../../AppRouter/crossFarmRoute';
import { CrossFarmDashboardCommonPageLoading } from './CrossFarmDashboardCommonPageLoading';
import { CrossFarmDashboardHomeLoading } from './CrossFarmDashboardHomeLoading';

export const CrossFarmDashboardPageLoading = ({
  pathname,
}: {
  pathname: string;
}) => {
  return isCrossFarmDashboardHomePathname(pathname) ? (
    <CrossFarmDashboardHomeLoading />
  ) : (
    <CrossFarmDashboardCommonPageLoading />
  );
};
